import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { addPlayer, updatePlayer } from '@/services/player'
import { PlayerReq } from '@/services/types/player'
import { Toast } from 'antd-mobile'
import { sleep } from 'antd-mobile/es/utils/sleep'
import SJButton from '@/components/SJButton'
import SJFormItem from '@/components/SJFormItem'
import './index.less'

type State = {
  type: 'add' | 'edit'
  playerId?: string
  faceId?: string
}

const PlayerName = () => {
  document.title = '棋手昵称'
  const navigate = useNavigate()
  const { state } = useLocation()
  const { type = 'edit', faceId = '', playerId } = state as State
  console.log(state)

  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)

  const onChangeName = (e: any) => {
    setName(e.target.value.trim())
  }

  const handleSubmit = async () => {
    if (loading) return
    if (name === '') {
      Toast.show('昵称不能为空')
      return
    }
    if (name.length > 12) {
      Toast.show('昵称不能超过12个字符')
      return
    }
    // eslint-disable-next-line
    const reg = /^[A-Za-z\u4e00-\u9fa5\s·\-]{1,12}$/ // 中英文，空格， · ，-
    if (!reg.test(name)) {
      Toast.show('昵称为1-12个字符，只支持中英文')
      return
    }
    setLoading(true)
    console.log(type)
    if (type === 'add') {
      createPlayer()
    }
    if (type === 'edit') {
      editPlayer(name)
    }
  }

  const createPlayer = async () => {
    try {
      await addPlayer({ faceId, name })
      Toast.show('棋手创建成功')
      await sleep(2000)
      setLoading(false)
      if (faceId) {
        navigate(-3)
      } else {
        navigate('/player')
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const editPlayer = async (_name: string) => {
    if (!playerId) return
    const params: PlayerReq = {
      playerId,
      name: _name,
    }
    try {
      await updatePlayer(params)
      setLoading(false)
      navigate(-1)
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <div className="page player-name">
      <div className="main">
        <div className="title">机器人将称呼您</div>
        <SJFormItem title="昵称">
          <input
            autoFocus
            className="name-input"
            placeholder="请输入昵称"
            value={name}
            onInput={onChangeName}
          />
        </SJFormItem>
        <div className="btn-fixed">
          <SJButton type="primary" size="large" onClick={handleSubmit}>
            保存
          </SJButton>
        </div>
      </div>
    </div>
  )
}
export default PlayerName
